import React, { useEffect } from 'react';
import { datadogRum } from '@datadog/browser-rum';
import { Typography, Button } from '../alf-design';

const styles = {
  error: {
    opacity: '10%',
    width: 'max-content',
  },
  oh: {
    fontSize: 'min(36rem, calc(36px * 1.5))',
    lineHeight: '36px',
    opacity: '10%',
  },
  title: {
    marginBottom: 8,
  },
  message: {
    fontSize: 'min(16rem, calc(16px * 1.5))',
  },
  button: {
    marginTop: 24,
  },
};

const NotFound = () => {
  useEffect(() => {
    datadogRum.addAction('error.not_found.viewed');
  }, []);

  return (
    <div className="block sm:flex items-center justify-center">
      <div className="flex flex-col items-center mr-[0px] sm:mr-[110px]">
        <Typography type="black" component="h1" style={styles.error}>
          404
        </Typography>
        <Typography type="black" component="h2" style={styles.oh}>
          uh - oh!
        </Typography>
      </div>
      <div className="justify-items-center sm:justify-items-start mt-[24px] sm:mt-[0px]">
        <Typography type="h1" component="h1" style={styles.title}>
          Page Not Found
        </Typography>
        <div>
          <Typography type="caption1" style={styles.message}>
            Looks like this page doesn’t exist.
          </Typography>
          <Typography type="caption1" style={styles.message}>
            Please return to the dashboard and try again.
          </Typography>
        </div>
        <div>
          <Button
            data-dd-action-name="error.not_found.back_to_dashboard"
            type="primary"
            style={styles.button}
            to="/"
          >
            Back to Dashboard
          </Button>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
